import React, { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import MainLayout from "../components/MainLayout";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import { PayrollHeader } from "../components/HeaderAttribute";
import { staffsalaryHeader } from '../components/HeaderAttribute';
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Payrollpopup from "../popup-containers/Payrollpopup";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";

const Payroll = () => {
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [MstSalaryPaidId, setMstSalaryPaidId] = useState(0);
  const [rowIndex, setRowIndex] = useState(null);

  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [monthDD, setmonthDD] = useState([]);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popupDataDD, setPopupDataDD] = useState([]);
  const [bindSalaryPaidData, setbindSalaryPaidData] = useState([]);



  const [formFields, setFormFields] = useState({
    month: "",
    salaryDate: "",

  });

  const [formFieldsError, setFormFieldsError] = useState({
    dateError: "",
    monthError: "",

  });

  const createdBy = sessionStorage.getItem("createdBy");


  const fieldLabels = {
    salaryDate: "Date",
    staffName: "Staff Name",
    grade: "Grade",

  };










  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleInputChange = (e) => {

    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };


  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `Enter the ${formattedName}.` : "",
    }));
  };



  const handleSubmit = async (rowIndex, flag) => {

  };







  const handleEdit = (rowIndex) => {


    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);



  };
  const handleSalaryPaid = (rowIndex, flag) => {
    ;
    setpopUpOpen(true);
    setRowIndex(rowIndex);


    setViewDetails(flag === 1);
    setDeleteDetails(flag === 3);
    setBlockDetails(flag === 4);
    setUnBlockDetails(flag === 5);

    // ✅ Pass actual staff dropdown data
    setPopupDataDD({
      // staffName: staffNameDD
    });
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setFormFields({
      staffName: "",
      salaryDate: "",
      grade: "",
      MstgradeId: 0,
      basicSalary: "",
      da: "",
      hra: "",
      convenience: "",
      medical: "",
      performance: "",
      others: "",
      grossSalaryTotal: "",
      pf: "",
      esi: "",
      insurance: "",
      loan: "",
      tax: "",
      deductionsTotal: "",
      nettotal: "",
      workingDays: "",
      presentDays: "",
      leaveDays: "",
      absentDays: "",
      totalAmounttobePaid: ""
    });
    // ();BindSalaryPaidGridDatas

  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setFormFields(prev => ({
      ...prev,
      workingDays: "",
      presentDays: "",
      leaveDays: "0",
      absentDays: "0",
      // totalAmounttobePaid: calculateTotalAmountToBePaid()
    }));
  };

  const handle1 = (value) => {
  }


  const dummyStaffSalaryData = [
    {
      sno: "1",
      GradeName: "A1",
      empno: "EMP-001",
      name: " Thavasi Iyyam perumal S",
      position: "Manager",
      DeductionsTotal: "Male",
      salarygrade: "Grade 1",
      totalamounttobepaid: "₹50,000"
    },
    {
      sno: "2",
      GradeName: "A1",
      empno: "EMP-002",
      name: "Marirajan P",
      position: "Manager",
      DeductionsTotal: "Male",
      salarygrade: "Grade 1",
      totalamounttobepaid: "₹50,000"
    },
    {
      sno: "3",
      GradeName: "A1",
      empno: "EMP-003",
      name: "Ponnumani M",
      position: "Manager",
      DeductionsTotal: "Male",
      salarygrade: "Grade 1",
      totalamounttobepaid: "₹50,000"
    },

    {
      sno: "4",
      GradeName: "A1",
      empno: "EMP-004",
      name: "Prem KrishnaKumar A",
      position: "Manager",
      DeductionsTotal: "Male",
      salarygrade: "Grade 1",
      totalamounttobepaid: "₹50,000"
    },
  ];


  const handleFieldsChange = async (value, name) => {

  };
  const payrollRecords = [
    {
      sno: 1,
      SalaryDate: "01-07-2025",
      StaffName: "June",
      TotalAmounttobePaid: "₹200,000",
      status: "Payment Processed",
    },
    {
      sno: 2,
      SalaryDate: "01-08-2025",
      StaffName: "July",
      TotalAmounttobePaid: "₹200,000",
      status: "Payment Processed",
    },

    {
      sno: 3,
      SalaryDate: "01-09-2025",
      StaffName: "August",
      TotalAmounttobePaid: "₹200,000",
      status: "Payment Processed",
    },
  ];

  return (
    <MainLayout pageName={"3"}>
      {visibleTable && (
        <GridPage
          title="Payroll"
          header={PayrollHeader}
          records={payrollRecords}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleSalaryPaid}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Payroll"
            />

            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className="grid gap-4 mb-6 md:grid-cols-3 px-4">
                    <InputText
                      inputType={"date"}
                      title={"Date"}
                      name={"salaryDate"}
                      classStar={"text-red-500"}
                      content={formFields.salaryDate}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          salaryDate: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setFormFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          dateError:
                            formFields.salaryDate && formFields.salaryDate.trim() !== ""
                              ? ""
                              : "Select Salary Date",
                        }));
                      }}
                      errorMessage={formFieldsError.dateError}
                    />
                    <AutoDropDown
                      title="Month"
                      name="month"
                      options={monthDD}
                      placeholder="Select"
                      selectedOption={monthDD.find((x) => x.value === formFields.month)}
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setFormFieldsError((prev) => ({
                          ...prev,
                          staffNameError: formFields.month ? "" : "Select Month Name",
                        }));
                      }}
                      errorMessage={formFieldsError?.monthError}
                    />


                  </div>
                  <div className="font-semibold px-4 ">Staff Salary Details</div>
                  <GridPageWithCheckBox
                    header={staffsalaryHeader ?? []}
                    records={dummyStaffSalaryData ?? []}
                    checkBoxStatus={handle1}
                   onSelectedGrid={setSelectedRowData}
                    isMultiSelect={true}
                    checkBoxVisible={true}
                    addView={true}
                    checkBoxHeaderVisible={true}
                    rowsPerPageView={true}
                   selectedRows={selectedRows ?? []}
                  />

                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled}
                  viewpayroll={true}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup popUpOpen={popUpOpen} setpopUpOpen={setpopUpOpen}>
        <div>
          <PopUpScreenTitle
            title="Salary Paid"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Payrollpopup data={popUpData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Payroll;